export default __webpack_public_path__ + "static/media/mobile-job_3.52221003.png";